<script>
	export let mensagem = "Carregando...";
</script>

<div class="modal is-active">
	<div class="modal-background"></div>
	<div class="modal-card has-text-centered">
		<p class="has-text-white">{mensagem}</p>
		<progress class="progress is-small is-primary" max="100">...</progress>
	</div>
</div>
